import * as types from './types';


const initialState = {
  iss: 0,
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  password: '',
  ibanGain: {
    status: 'idle',
    data: '',
  },
  investment: window.sessionStorage.getItem('amount') || 0,
  isConnected: false,
  wantInvestBySociety: window.sessionStorage.getItem('from_company') === 'true',
  uploading: false,
  loading: false,
  error: false,
  connectionSuccess: false,
  errorMessage: '',
  resaId: 'unknown',
}

type AccountAction = {
  type: typeof types[keyof typeof types];
  payload?: Partial<types.AccountState>;
};


export default function accountReducer(state = initialState, action: AccountAction) {
  switch (action.type) {
    case 'SEND_IBAN_REQUEST':
      return {
        ...state,
        ibanGain: {
          ...state.ibanGain,
          status: 'loading',
        }
      };
    case 'SEND_IBAN_SUCCESS':
      return {
        ...state,
        ibanGain: {
          ...state.ibanGain,
          status: 'success'
        }
      };
    case 'SEND_IBAN_FAIL':
      return {
        ...state,
        ibanGain: {
          ...state.ibanGain,
          status: 'fail'
        }
      }
    case 'CREATE_ACCOUNT':
      return { ...state, uploading: true, loading: true };
    case 'CREATE_ACCOUNT_SUCCESS':
      return { ...action.payload, uploading: false, loading: false };
    case 'CREATE_ACCOUNT_ERROR':
      return { ...state, uploading: false, loading: false };
    case 'CONNECT_ACCOUNT':
      return { ...state, loading: true };
    case 'CONNECT_ACCOUNT_SUCCESS':
      return { ...state, loading: false, error: false, connectionSuccess: true, errorMessage: '' };
    case 'CONNECT_ACCOUNT_FAIL':
      return { ...state, loading: false, error: true, connectionSuccess: false, errorMessage: action.payload };
    case 'UPDATE_FIRSTNAME':
      return { ...state, firstname: action.payload }
    case 'UPDATE_LASTNAME': {
      return { ...state, lastname: action.payload }
    }
    case 'UPDATE_MAIL': {
      return { ...state, email: action.payload }
    }
    case 'UPDATE_PHONE': {
      return { ...state, phone: action.payload }
    }
    case 'UPDATE_PASSWORD': {
      return { ...state, password: action.payload }
    }
    case 'UPDATE_SOCIETY': {
      return { ...state, wantInvestBySociety: action.payload }
    }
    case 'UPDATE_IBAN_GAIN': {
      return { ...state, ibanGain: action.payload }
    }
    case 'UPDATE_RESERVATION_ID': {
      return { ...state, resaId: action.payload }
    }
    case 'SET_ACCOUNT_DATA': {
      return { ...state, ...action.payload }
    }
    default:
      return state;
  }
}
